module.exports = __webpack_public_path__ + "static/media/girl-13.579e2fd4.svg";